import { FetchError, NotFoundError } from '../..';
import { checkError } from './check-error';

const tripRegex = new RegExp('[a-zA-Z]{0,1}[0-9]{7,9}');

const fetchOptions = {
  method: 'GET',
  headers: {
    'Content-Type': 'application/json',
    Accept: 'application/json'
  }
};

export const getSearchResults = async (search: string, baseUrl?: string) => {
  try {
    const response = await fetch(`${baseUrl ?? '/v1/cv_search'}/${search}`, fetchOptions);
    checkError(response);
    return await response.json();
  } catch (error: any) {
    console.log(`Error: Unable to get search results. ${error?.message}`);
    return [
      {
        link: '',
        text: 'There was a problem finding results...',
        title: ''
      }
    ];
  }
};

export const getSearchResultsMulti = async (search: string, searchUrl?: string) => {
  try {
    const searchfetch = await fetch(`${searchUrl ?? '/v1/cv_search'}/${search}`, fetchOptions);
    checkError(searchfetch);
    return searchfetch.json();
  } catch (error: any) {
    console.log(`Error: Unable to get search results. ${error?.message}`);
    return [
      {
        link: '',
        text: 'There was a problem searching for hotels, tours and destinations...',
        title: ''
      }
    ];
  }
};

export const getTripResults = async (search: string, tripsUrl?: string) => {
  //only search for trips, if we have token, and meet search regex

  if (search && tripRegex.test(search)) {
    try {
      const tripsFetch = await fetch(`${tripsUrl ?? '/trip-service/v1/trips'}/${search.toUpperCase()}`, fetchOptions);

      checkError(tripsFetch);

      return tripsFetch.json().then((r) => {
        return [
          {
            link: `/trips/${r.id}`,
            text: r.id,
            secondary: r.duration,
            title: 'Booking'
          }
        ];
      });
    } catch (error) {
      if (error instanceof FetchError) {
        console.log(`Error: Unable to get trip results. ${error?.message}`);
      }
    }
  }
  return Promise.resolve([]);
};

export const getSearchAndBookingResults = async (
  search: string,
  searchUrl?: string,
  tripsUrl?: string,
  authenticated?: boolean
) => {
  try {
    const searchfetch = getSearchResultsMulti(search, searchUrl);
    const tripsFetch = authenticated && tripsUrl ? getTripResults(search, tripsUrl) : Promise.resolve([]);

    const [tripResults, searchResults] = [await tripsFetch, await searchfetch];

    return [...tripResults, ...searchResults];
  } catch (error: any) {
    console.log(`Error: Unable to get search results. ${error?.message}`);
    return [
      {
        link: '',
        text: 'There was a problem finding results...',
        title: ''
      }
    ];
  }
};
